export default __webpack_public_path__ + "static/media/person-icon.98f34add.svg";